"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var LogoJcb = function LogoJcb() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "36",
    height: "27",
    viewBox: "0 0 36 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.3937 0.14033C2.05512 0.14033 0 2.17084 0 4.4114C0 5.67172 0 10.643 0 15.5442C0.425197 15.8243 2.40945 16.4544 3.25984 16.5245C5.0315 16.6645 6.09449 16.1043 6.30709 14.634V9.24262H10.2047V14.4939C9.99213 17.5047 7.29921 18.1349 3.25984 17.9248C2.12598 17.8548 0.708661 17.5747 0 17.4347C0 22.3359 0 26.747 0 26.747C0 26.747 5.10236 26.747 6.80315 26.747C8.64567 26.747 11.0551 25.0666 11.0551 22.4059C11.0551 18.0648 11.0551 0.0703125 11.0551 0.0703125C11.0551 0.0703125 6.09449 0.14033 4.3937 0.14033Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.8663 0.140035C14.5986 0.140035 12.5435 2.17055 12.5435 4.41111C12.5435 5.1813 12.5435 7.49188 12.5435 10.2926C13.8899 9.24232 16.0868 8.7522 18.9214 8.96225C20.4805 9.10229 21.6852 9.31234 22.323 9.52239V11.3429C21.6143 10.9928 20.197 10.5026 19.0631 10.3626C16.4411 10.1526 15.0238 11.4129 15.0238 13.3734C15.0238 15.1238 16.0868 16.6642 19.0631 16.4541C20.0553 16.3841 21.6143 15.824 22.323 15.4739V17.2943C21.7561 17.5044 19.9135 17.8545 18.1419 17.8545C15.5198 17.8545 13.6773 17.2943 12.5435 16.4541C12.5435 21.7055 12.5435 26.6767 12.5435 26.6767C12.5435 26.6767 17.6458 26.6767 19.3466 26.6767C21.1891 26.6767 23.5986 24.9963 23.5986 22.3356C23.5986 17.9945 23.5986 0 23.5986 0C23.5986 0 18.5671 0.140035 16.8663 0.140035Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M29.7637 14.0034C28.9842 14.0034 27.4251 14.0034 27.0708 14.0034V16.384H29.7637C30.2598 16.384 30.8976 15.9639 30.8976 15.1937C30.8976 14.4935 30.3306 14.0034 29.7637 14.0034Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30.6141 11.623C30.6141 10.9228 30.118 10.5027 29.5511 10.5027C28.7716 10.5027 27.4251 10.5027 27.0708 10.5027V12.6732H29.5511C29.9763 12.6732 30.6141 12.3231 30.6141 11.623Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M29.2677 0.140869C26.9999 0.140869 24.9448 2.17138 24.9448 4.41194C24.9448 5.11212 24.9448 6.86256 24.9448 9.17314H31.3936C32.6692 9.17314 34.2283 9.73328 34.2283 11.2737C34.2283 12.1139 33.8031 13.0241 32.1732 13.3742V13.4442C33.0944 13.4442 34.7243 14.0044 34.7243 15.6148C34.7243 17.2952 32.9527 17.7853 32.0314 17.7853H24.9448C24.9448 22.6165 24.9448 26.8176 24.9448 26.8176C24.9448 26.8176 30.0472 26.8176 31.748 26.8176C33.5905 26.8176 35.9999 25.1372 35.9999 22.4765C35.9999 18.1354 35.9999 0.140869 35.9999 0.140869C35.9999 0.140869 30.9684 0.140869 29.2677 0.140869Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "paint0_linear",
    x1: "0.00609449",
    y1: "13.4516",
    x2: "11.0752",
    y2: "13.4516",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#313578"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#0077BD"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "paint1_linear",
    x1: "12.4802",
    y1: "13.4513",
    x2: "23.5493",
    y2: "13.4513",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#763137"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#EE1846"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "paint2_linear",
    x1: "27.0722",
    y1: "15.1712",
    x2: "30.9031",
    y2: "15.1712",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#008149"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#62BB45"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "paint3_linear",
    x1: "27.0588",
    y1: "11.5959",
    x2: "30.5798",
    y2: "11.5959",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#008149"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#62BB45"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "paint4_linear",
    x1: "24.8959",
    y1: "13.4521",
    x2: "35.9649",
    y2: "13.4521",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#008149"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#62BB45"
  }))));
};
var _default = LogoJcb;
exports.default = _default;